module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.config.loading.save),
      expression: "config.loading.save",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": "Aguarde enquanto a liberação é concluída..."
    }
  }, [_c('ed-modal', {
    attrs: {
      "title": 'LIBERAR ASO' + _vm.title,
      "modal": _vm.parent.showLiberacao,
      "loadingSave": _vm.config.loading.save,
      "loading": _vm.config.loading.content,
      "onSave": _vm.asoLiberada || _vm.asoNaoAssinada || _vm.asoSemUploadOuConfig ? null : _vm.salvar,
      "currentTab": _vm.tagConfig
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-unlock"
  }), _vm._v(" Liberar ASO")]), _vm._v(" "), (_vm.asoLiberada) ? _c('div', {
    staticClass: "aso-alert"
  }, [_c('el-alert', {
    attrs: {
      "title": "Consulta já liberada",
      "closable": false,
      "description": "A consulta já está liberada e não pode ser liberada novamente.",
      "type": "success",
      "show-icon": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.asoLiberada && _vm.asoNaoAssinada) ? _c('div', {
    staticClass: "aso-alert"
  }, [_c('el-alert', {
    attrs: {
      "title": "ASO não assinado pelo funcionário",
      "closable": false,
      "description": "O funcionário ainda não assinou o ASO. A assinatura é obrigatória antes da liberação.",
      "type": "warning",
      "show-icon": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.asoLiberada && !_vm.asoNaoAssinada && _vm.asoSemUploadOuConfig) ? _c('div', {
    staticClass: "aso-alert"
  }, [_c('el-alert', {
    attrs: {
      "title": "Upload do ASO ou configuração da empresa necessários",
      "closable": false,
      "description": "É necessário fazer o upload do ASO previamente, ou habilitar as opções 'Assinar ASO com Certificado' e 'Incluir Assinatura no ASO' no cadastro da empresa.",
      "type": "warning",
      "show-icon": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.asoLiberada && !_vm.asoNaoAssinada && !_vm.asoSemUploadOuConfig) ? _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "itens": _vm.formItems,
      "response": _vm.response
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })]) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-historico"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    class: 'fa fa-history' + (_vm.novaLiberacao ? ' faa-flash animated' : '')
  }), _vm._v("\n            Histórico de Liberação\n          ")]), _vm._v(" "), _c('TableView', {
    attrs: {
      "onSearch": _vm.getConsultaLiberacao,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.config.loading.table,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "disableInputSearch": "",
      "disabledConfigCell": "",
      "disableCheckAll": ""
    }
  })], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65d72154"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/consulta/liberacao/_includes/liberar-aso.vue
// module id = 1507
// module chunks = 45